export const zhI18n = {
  emptyText: "暂无数据",
  pleaseChoose: "请选择",
  confirm: "确认",
  cancel: "取消",
  chooseAll: "全选",
  reset: "重置",
  sure: "确定",
};

export const enI18n = {
  emptyText: "No data",
  pleaseChoose: "Please choose",
  confirm: "Confirm",
  cancel: "Cancel",
  chooseAll: "Choose all",
  reset: "Reset",
  sure: "Confirm",
};

export const getTranslateNsT = (local: "zh" | "en") => {
  return (key: string) =>
    ({
      zh: zhI18n,
      en: enI18n,
    }[local][key] || "");
};
